import { faCircleQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LegacyButton as Button } from "web-ui/legacy";

import styles from "../styles/HelpButton.module.scss";

export const HelpButton = ({ instructions }: { instructions: string }) => (
  <Button
    className={styles["help-button"]}
    onClick={() =>
      alert(
        `${instructions}\n\nFun fact: You can see these instructions again just by hovering over the icon.`,
      )
    }
    title={instructions}
  >
    <FontAwesomeIcon icon={faCircleQuestion} size="2x" />
  </Button>
);
